import Vue from 'vue';
import {
  Carousel,
  carouselItem,
  Aside,
  Autocomplete,
  Button,
  ButtonGroup,
  Card,
  Cascader,
  CascaderPanel,
  Checkbox,
  CheckboxGroup,
  Col,
  Collapse,
  CollapseItem,
  Container,
  DatePicker,
  Dialog,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Form,
  FormItem,
  Header,
  Input,
  InputNumber,
  Loading,
  Main,
  Menu,
  MenuItem,
  MenuItemGroup,
  Message,
  MessageBox,
  Notification,
  Option,
  OptionGroup,
  Pagination,
  Popover,
  Radio,
  RadioButton,
  RadioGroup,
  Row,
  Select,
  Submenu,
  Switch,
  TabPane,
  Table,
  TableColumn,
  Tabs,
  Tag,
  Tooltip,
  Tree,
  Upload,
  Steps,
  Step,
  Timeline,
  TimelineItem,
  Avatar,
  TimePicker,
  Link,
  Divider,
  Image,
} from 'element-ui';

const components = [
  Carousel,
  carouselItem,
  Container,
  Aside,
  Header,
  Main,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Row,
  Col,
  Radio,
  ButtonGroup,
  RadioButton,
  Tabs,
  TabPane,
  Form,
  FormItem,
  Select,
  OptionGroup,
  Option,
  Button,
  Input,
  Table,
  TableColumn,
  Pagination,
  Card,
  Collapse,
  CollapseItem,
  Checkbox,
  DatePicker,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Switch,
  Dialog,
  Autocomplete,
  Loading,
  Cascader,
  CascaderPanel,
  Tree,
  CheckboxGroup,
  Upload,
  Tooltip,
  Popover,
  RadioGroup,
  InputNumber,
  Tag,
  Steps,
  Step,
  Timeline,
  TimelineItem,
  Avatar,
  TimePicker,
  Link,
  Divider,
  Image,
];

const install = function () {
  components.map(component => {
    Vue.use(component);
    Vue.use(Loading.directive);
  });
  Vue.prototype.$ELEMENT = { size: 'mini' };
  Vue.prototype.$loading = Loading.service;
  Vue.prototype.$msgbox = MessageBox;
  Vue.prototype.$alert = MessageBox.alert;
  Vue.prototype.$confirm = MessageBox.confirm;
  Vue.prototype.$prompt = MessageBox.prompt;
  Vue.prototype.$message = Message;
  Vue.prototype.$notify = Notification;
};

export default { install };
